export const COURT_INTELLIGENCE_FOUNDING_VENUES_PATH = '/court-intelligence/founding-venues';
export const COURT_INTELLIGENCE_FOUNDING_VENUES_URL = `https://whoplays.us${COURT_INTELLIGENCE_FOUNDING_VENUES_PATH}`;

export function buildCourtIntelligenceShareMailto(subject: string, body: string) {
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
    body.replace('{url}', COURT_INTELLIGENCE_FOUNDING_VENUES_URL),
  )}`;
}
